/* WPL Marine Weighing — interactie zonder framework.
   Offertemandje (localStorage), uitvoeringentabel, galerij, inhoudsopgave. */
(() => {
  'use strict';
  const KEY = 'wpl-quote-v1';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  /* ---------------- quote store ---------------- */
  const Quote = {
    read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } },
    write(items) {
      try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('quote:change', { detail: items }));
    },
    add(item) { const items = Quote.read(); items.push(item); Quote.write(items); },
    remove(i) { const items = Quote.read(); items.splice(i, 1); Quote.write(items); },
    clear() { Quote.write([]); }
  };
  window.WPLQuote = Quote;

  const paintCount = () => {
    const n = Quote.read().reduce((s, it) => s + (parseInt(it.qty, 10) || 1), 0);
    $$('[data-quote-count]').forEach(el => { el.textContent = n; });
    $$('[data-quote-pill]').forEach(el => el.toggleAttribute('data-empty', n === 0));
  };
  document.addEventListener('quote:change', paintCount);
  window.addEventListener('storage', e => { if (e.key === KEY) paintCount(); });

  /* ---------------- SKU (zelfde regels als het canvas) ---------------- */
  const OPT_CODES = { 'WeightControl IOT': 'WC', 'Bluetooth LE': 'BT', 'Battery': 'BA', 'USB': 'US', 'RS232': 'RS',
    'Ethernet': 'ET', 'WiFi': 'WF', 'Column mount': 'CM', 'Windcover': 'WV', 'Carrying case': 'CC', 'Wall mount': 'WM',
    'EURAMET cg-18 calibration': 'K18', 'R10 indicator': 'R10', 'Indicator column': 'IC', 'Dual range': 'DR',
    'Verified version (M marking)': 'M', 'ATEX load cell': 'AX', 'High-resolution load cell (C4/C6)': 'HR',
    'WI stainless version': 'WI', 'Stainless steel plate': 'SP', 'CSI stainless load cells': 'CSI', 'Pit version': 'PIT',
    'Stainless steel version': 'SS', 'Custom dimensions': 'CD' };
  const sku = (model, platform, capacity, options) => {
    const size = (platform.size || '').replace(/\s*[×x]\s*/, 'x');
    const capTok = (capacity.label.match(/([\d.]+(?:[–-][\d.]+)?)\s*(kg|g|t)\b/i) || []).slice(1).map((v, i) => i ? v.toUpperCase() : v.replace('.', '')).join('');
    const code = (platform.code || model).replace('-', '').toUpperCase();
    const opt = options.map(o => OPT_CODES[o]).filter(Boolean).join('');
    return ['WPL', code, size, capTok].filter(Boolean).join('-') + (opt ? '-' + opt : '');
  };

  /* ---------------- uitvoeringentabel (zoals weegexperts) ---------------- */
  class WplVariants extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse($('script[type="application/json"]', this).textContent);
      this.rows = $$('.vt-row', this);
      this.rows.forEach(row => this.update(row));
      this.addEventListener('change', e => {
        const row = e.target.closest('.vt-row');
        if (row && e.target.name === 'option') this.update(row);
      });
      this.addEventListener('click', e => {
        const t = e.target.closest('button');
        if (!t || !this.contains(t)) return;
        const row = t.closest('.vt-row');
        if (t.dataset.filter !== undefined) return this.filter(t);
        if (!row) return;
        if (t.hasAttribute('data-opts-toggle')) {
          const open = t.getAttribute('aria-expanded') !== 'true';
          t.setAttribute('aria-expanded', open);
          $('.vt-opts', row).hidden = !open;
          row.classList.toggle('is-open', open);
        } else if (t.dataset.step) {
          const input = $('.qty-step input', row);
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(t.dataset.step, 10));
        } else if (t.hasAttribute('data-add')) {
          this.add(row, t);
        }
      });
    }
    parts(row) {
      const p = this.data.platforms.find(x => x.id === row.dataset.platform);
      const c = this.data.capacities.find(x => x.id === row.dataset.capacity);
      const opts = $$('input[name="option"]:checked', row).map(i => i.value);
      return { p, c, opts };
    }
    update(row) {
      const { p, c, opts } = this.parts(row);
      $('.vt-sku output', row).textContent = sku(this.data.model, p, c, opts);
      const count = $('[data-opt-count]', row);
      if (count) { count.textContent = opts.length; count.hidden = !opts.length; }
    }
    filter(btn) {
      $$('[data-filter]', this).forEach(b => b.setAttribute('aria-pressed', b === btn));
      this.rows.forEach(r => { r.hidden = !!btn.dataset.filter && r.dataset.platform !== btn.dataset.filter; });
    }
    add(row, btn) {
      const { p, c, opts } = this.parts(row);
      const qty = Math.max(1, parseInt($('.qty-step input', row).value, 10) || 1);
      Quote.add({ product: this.data.title, url: location.pathname, qty, platform: p.label, capacity: c.label,
        options: opts, sku: sku(this.data.model, p, c, opts) });
      if (!btn.dataset.label) btn.dataset.label = btn.textContent;
      btn.textContent = btn.dataset.done;
      btn.classList.add('is-done');
      clearTimeout(btn._t);
      btn._t = setTimeout(() => { btn.textContent = btn.dataset.label; btn.classList.remove('is-done'); }, 1800);
    }
  }
  customElements.define('wpl-variants', WplVariants);

  /* brochure op aanvraag: e-mail controleren voor verzenden */
  document.addEventListener('submit', e => {
    const f = e.target.closest('.gate__form');
    if (!f) return;
    const mail = $('input[type="email"]', f), hint = $('.gate__hint', f);
    const ok = /^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(mail.value.trim());
    mail.value = mail.value.trim();
    if (hint) hint.hidden = ok;
    mail.setCustomValidity(ok ? '' : (hint ? hint.textContent : 'Invalid email'));
    if (!ok || !f.checkValidity()) { e.preventDefault(); f.reportValidity(); }
  });
  document.addEventListener('input', e => {
    if (e.target.matches('.gate__form input[type="email"]')) e.target.setCustomValidity('');
  });

  /* eenvoudige "vraag offerte aan" voor producten zonder configurator */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-quote-simple]');
    if (!b) return;
    Quote.add({ product: b.dataset.quoteSimple, url: location.pathname, qty: 1, options: [] });
    const f = b.parentElement.querySelector('.flash');
    if (f) { f.classList.add('is-on'); setTimeout(() => f.classList.remove('is-on'), 1800); }
  });

  /* ---------------- quote page ---------------- */
  class QuoteBasket extends HTMLElement {
    connectedCallback() {
      this.list = $('.basket', this);
      this.empty = $('.empty-note', this);
      this.field = document.getElementById(this.dataset.field);
      if (location.search.includes('contact_posted=true')) Quote.clear();
      this.render();
      document.addEventListener('quote:change', () => this.render());
      this.list.addEventListener('click', e => {
        const b = e.target.closest('[data-remove]');
        if (b) Quote.remove(parseInt(b.dataset.remove, 10));
      });
    }
    render() {
      const items = Quote.read(), t = this.dataset;
      this.empty.hidden = items.length > 0;
      this.list.innerHTML = '';
      items.forEach((it, i) => {
        const li = document.createElement('li');
        const detail = [it.platform, it.capacity, (it.options || []).join(', ')].filter(Boolean).join(' · ');
        li.innerHTML = `<div><strong></strong><div class="mono"></div><div class="mono"></div></div>
          <div><span class="mono"></span> <button type="button" data-remove="${i}"></button></div>`;
        $('strong', li).textContent = `${it.qty}× ${it.product}`;
        $$('.mono', li)[0].textContent = it.sku ? `${t.skuLabel} ${it.sku}` : '';
        $$('.mono', li)[1].textContent = detail;
        $('button', li).textContent = t.removeLabel;
        this.list.appendChild(li);
      });
      if (this.field) {
        this.field.value = items.map(it => `${it.qty} × ${it.product}${it.sku ? ` [${it.sku}]` : ''}` +
          [it.platform, it.capacity, (it.options || []).join(', ')].filter(Boolean).map(s => `\n   - ${s}`).join('')).join('\n\n');
      }
    }
  }
  customElements.define('quote-basket', QuoteBasket);

  /* ---------------- hero slider ---------------- */
  class WplSlider extends HTMLElement {
    connectedCallback() {
      this.slides = $$('.slider__slide', this);
      this.dots = $$('.slider__dot', this);
      if (this.slides.length < 2) return;
      this.i = 0;
      this.ms = parseInt(this.dataset.interval, 10) || 5000;
      this.style.setProperty('--slide-ms', this.ms + 'ms');
      this.still = matchMedia('(prefers-reduced-motion: reduce)').matches;
      $('[data-next]', this)?.addEventListener('click', () => this.go(this.i + 1, true));
      $('[data-prev]', this)?.addEventListener('click', () => this.go(this.i - 1, true));
      this.dots.forEach(d => d.addEventListener('click', () => this.go(parseInt(d.dataset.go, 10), true)));
      // pauzeren bij hover/focus en als de slider uit beeld is
      ['mouseenter', 'focusin'].forEach(e => this.addEventListener(e, () => this.pause(true)));
      ['mouseleave', 'focusout'].forEach(e => this.addEventListener(e, () => this.pause(false)));
      new IntersectionObserver(([en]) => this.pause(!en.isIntersecting)).observe(this);
      let x0 = null;
      this.addEventListener('pointerdown', e => { x0 = e.clientX; });
      this.addEventListener('pointerup', e => {
        this.geveegd = x0 !== null && Math.abs(e.clientX - x0) > 40;
        if (this.geveegd) this.go(this.i + (e.clientX < x0 ? 1 : -1), true);
        x0 = null;
      });
      // na een veegbeweging niet ook de productlink volgen
      this.addEventListener('click', e => { if (this.geveegd) { e.preventDefault(); this.geveegd = false; } }, true);
      this.plan();
    }
    go(n, handmatig) {
      const len = this.slides.length;
      this.i = (n + len) % len;
      this.slides.forEach((s, k) => {
        const aan = k === this.i;
        s.classList.toggle('is-active', aan);
        s.setAttribute('aria-hidden', !aan);
        s.tabIndex = aan ? 0 : -1;
      });
      this.dots.forEach((d, k) => {
        d.classList.remove('is-active'); void d.offsetWidth;   // herstart de voortgangsbalk
        d.classList.toggle('is-active', k === this.i);
        d.setAttribute('aria-selected', k === this.i);
      });
      if (handmatig) this.plan();
    }
    plan() {
      clearInterval(this.t);
      if (this.still) return;
      this.t = setInterval(() => { if (!this.paused) this.go(this.i + 1); }, this.ms);
    }
    pause(p) {
      const was = this.paused;
      this.paused = p;
      this.classList.toggle('is-paused', p);
      if (was && !p) this.go(this.i, true);   // na hover of uit beeld: huidige slide krijgt weer de volle tijd
    }
  }
  customElements.define('wpl-slider', WplSlider);

  /* ---------------- motion demo: schip en uitlezing op één klok ---------------- */
  $$('[data-motion-sync]').forEach(box => {
    const boat = $('[data-boat]', box), wave = $('[data-wave]', box);
    const raw = $('[data-raw]', box), comp = $('[data-comp]', box);
    const nominal = parseFloat(box.dataset.nominal) || 10;
    const swing = parseFloat(box.dataset.swing) || 0.25;          // 9,750 – 10,250 kg
    const period = (parseFloat(box.dataset.period) || 4) * 1000;
    const fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
    comp.textContent = fmt.format(nominal) + ' kg';
    raw.textContent = fmt.format(nominal) + ' kg';
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let zichtbaar = false, start = null, laatsteTekst = 0;
    new IntersectionObserver(([en]) => { zichtbaar = en.isIntersecting; if (zichtbaar) requestAnimationFrame(tik); }).observe(box);
    function tik(nu) {
      if (!zichtbaar) return;
      if (start === null) start = nu;
      const fase = ((nu - start) % period) / period * Math.PI * 2;
      const hoogte = Math.sin(fase);                     // +1 = schip bovenop de golf, -1 = in het dal
      boat.setAttribute('transform', `translate(0 ${(-hoogte * 16).toFixed(2)}) rotate(${(Math.cos(fase) * 2.5).toFixed(2)} 300 90)`);
      wave.setAttribute('transform', `translate(${(-((nu - start) / period) * 150 % 150).toFixed(2)} ${(-hoogte * 6).toFixed(2)})`);
      if (nu - laatsteTekst > 90) {                      // ~11x per seconde: leesbaar, niet flikkerend
        raw.textContent = fmt.format(nominal + hoogte * swing) + ' kg';   // omhoog = zwaarder, omlaag = lichter
        // gecompenseerd: realistisch één stapje (1 g) hoger zolang het schip omhoog beweegt, terug op nominaal als het daalt
        const stijgt = Math.cos(fase) > 0;
        const tekst = fmt.format(nominal + (stijgt ? 0.001 : 0)) + ' kg';
        if (comp.textContent !== tekst) comp.textContent = tekst;
        laatsteTekst = nu;
      }
      requestAnimationFrame(tik);
    }
  });

  /* ---------------- gallery ---------------- */
  $$('[data-gallery]').forEach(g => {
    const main = $('.product-stage img', g);
    if (!main) return;
    $$('[data-gallery-thumb]', g).forEach(btn => btn.addEventListener('click', () => {
      main.src = btn.dataset.src; main.srcset = btn.dataset.srcset || ''; main.alt = btn.dataset.alt || main.alt;
      $$('[data-gallery-thumb]', g).forEach(b => b.setAttribute('aria-current', b === btn));
    }));
  });

  /* ---------------- table of contents ---------------- */
  const toc = $('[data-toc]');
  const body = $('[data-toc-source]');
  if (toc && body) {
    const heads = $$('h2[id]', body);
    // zonder inhoudsopgave schuift de grid anders op en belandt de tekst in de smalle 260px-kolom
    if (heads.length < 2) { const layout = toc.closest('.article-layout'); toc.closest('.toc')?.remove(); layout?.classList.add('article-layout--no-toc'); }
    else {
      const ol = $('ol', toc);
      heads.forEach(h => {
        const li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); ol.appendChild(li);
      });
      const links = $$('a', ol);
      const io = new IntersectionObserver(entries => entries.forEach(en => {
        if (en.isIntersecting) links.forEach(a => a.setAttribute('aria-current', a.hash === '#' + en.target.id));
      }), { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach(h => io.observe(h));
    }
  }

  /* ---------------- misc ---------------- */
  $$('[data-autosubmit]').forEach(el => el.addEventListener('change', () => el.form.submit()));
  $$('video[data-lazy]').forEach(v => {
    const io = new IntersectionObserver(([en]) => {
      if (en.isIntersecting) { v.src = v.dataset.lazy; v.play().catch(() => {}); io.disconnect(); }
    });
    io.observe(v);
  });
  paintCount();
})();

/* Hoofdmenu: één uitklapmenu tegelijk open; sluiten bij klik buiten het menu of Escape */
(() => {
  const dds = [...document.querySelectorAll('.nav__dd > details')];
  if (!dds.length) return;
  dds.forEach(d => d.addEventListener('toggle', () => {
    if (d.open) dds.forEach(o => { if (o !== d) o.open = false; });
  }));
  document.addEventListener('click', e => { if (!e.target.closest('.nav__dd')) dds.forEach(d => { d.open = false; }); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') dds.forEach(d => { d.open = false; }); });
})();
